import { alpha, Box, Collapse, Divider, Drawer, IconButton, Link, List, ListItem, makeStyles } from "@material-ui/core";
import { ExpandLessOutlined, ExpandMoreOutlined, Menu, OpenInNew } from "@material-ui/icons";
import { Fragment, useState } from "react";
import { NavLink, Link as RouterLink } from "react-router-dom";
import logo from "src/assets/images/logo/logo_blue_white.png";
import navigationConfig, { rightNavConfig } from "src/configs/navigation";

const useStyles = makeStyles((theme) => ({
  menuIconBtn: {
    marginRight: theme.spacing(-1.5),
  },
  sidebarList: {
    minWidth: "250px",
  },
  listItem: {
    textTransform: "capitalize",
    fontWeight: 500,
    cursor: "pointer",
    margin: "0px 8px",
    color: alpha(theme.palette.common.white, 0.65),
  },
  selectListItem: {
    textTransform: "capitalize",
    fontWeight: 500,
    cursor: "pointer",
    margin: "8px 8px",
    color: alpha(theme.palette.common.white, 0.65),
  },
  navLink: {
    padding: "8px 0px",
    color: alpha(theme.palette.common.white, 0.65),
    textDecoration: "none",
    fontSize: "0.9rem",
    cursor: "pointer",
    transition: "color 300ms linear",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  activeLink: {
    color: theme.palette.primary.main,
  },
  groupItemList: {
    backgroundColor: "#071426",
    "& $navLink": {
      fontSize: "0.8rem",
      lineHeight: 0,
      display: "flex",
      alignItems: "center",
    },
  },
}));

export default function Sidebar() {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [activeGroupItem, setActiveGroupItem] = useState(undefined);
  const cls = useStyles();

  function toggleSidebar() {
    setOpenSidebar(!openSidebar);
  }

  function handleSidebarClose() {
    setOpenSidebar(false);
    setActiveGroupItem(undefined);
  }

  function toggleGroupItem(groupId) {
    if (activeGroupItem === groupId) {
      setActiveGroupItem(undefined);
    } else {
      setActiveGroupItem(groupId);
    }
  }

  function renderNavItem(item) {
    const AnchorTag = item.externalLink ? Link : NavLink;
    return (
      <AnchorTag
        onClick={handleSidebarClose}
        className={cls.navLink}
        activeClassName={cls.activeLink}
        href={item.externalLink ? item.navLink : undefined}
        target={item.newTab ? "_blank" : undefined}
        to={item.externalLink ? undefined : item.navLink}
      >
        {item.title}
        {item.externalLink && <OpenInNew style={{ marginLeft: 4, fontSize: "inherit" }} />}
      </AnchorTag>
    );
  }

  return (
    <>
      <IconButton onClick={toggleSidebar} className={cls.menuIconBtn}>
        <Menu style={{ color: "rgba(255, 255, 255, 0.65)" }} fontSize="medium" />
      </IconButton>
      <Drawer anchor="right" open={openSidebar} onClose={handleSidebarClose}>
        <List className={cls.sidebarList}>
          <ListItem onClick={handleSidebarClose}>
            <Link component={RouterLink} to="/">
              <img src={logo} alt="Logo" style={{ height: "36px", verticalAlign: "middle" }} />
            </Link>
          </ListItem>
          <Divider style={{ marginBottom: "16px" }} />
          {[...navigationConfig, ...rightNavConfig].map((item, _) => {
            return item.children || item.forceShowInSidebar ? (
              <Fragment key={item.id}>
                <ListItem onClick={() => toggleGroupItem(item.id)} className={cls.selectListItem}>
                  <Box display="flex" alignItem="center">
                    {item.title}{" "}
                    {item.id === activeGroupItem ? (
                      <ExpandLessOutlined fontSize="small" />
                    ) : (
                      <ExpandMoreOutlined fontSize="small" />
                    )}
                  </Box>
                </ListItem>
                <Box px={2}>
                  <Collapse in={item.id === activeGroupItem}>
                    <List className={cls.groupItemList}>
                      {item?.children &&
                        item.children.map((cItem) => (
                          <ListItem key={cItem.id} button className={cls.listItem}>
                            {renderNavItem(cItem)}
                          </ListItem>
                        ))}
                      {item?.forceShowInSidebar &&
                        item.forceShowInSidebar.map((cItem) => (
                          <ListItem key={cItem.id} button className={cls.listItem}>
                            {renderNavItem(cItem)}
                          </ListItem>
                        ))}
                    </List>
                  </Collapse>
                </Box>
              </Fragment>
            ) : (
              <ListItem key={item.id} className={cls.listItem}>
                {renderNavItem(item)}
              </ListItem>
            );
          })}
        </List>
        <Box py={2} />
      </Drawer>
    </>
  );
}
